// ============================================================
// fondos/efectos/topographic.js — «Topográfico»: curvas de nivel que ondulan despacio (efecto de
// LIENZO)
//
// Portado de `vendor/bg/topographic-bg.js` en la F2b del P3 con el MISMO dibujo (el test de espejo lo
// compara llamada a llamada con la clase de siempre): líneas finas apiladas, cada una suma de dos
// senos con su fase y su frecuencia. Avanza por RELOJ (función de `t`): su velocidad nunca dependió
// de los fps, solo su suavidad (hoy ~18 fps con tirones; con el motor, 30 regulares). El alfa de las
// líneas es el tope del catálogo (`alfaMax`, F3).
// ============================================================

import { rgbDeBase } from './comun.js';

export default {
    crear(ctx, e) {
        const p = e.params;
        const dn = p.density != null ? p.density : 5;
        // Densidad 1-10 → 10-18 líneas (7-15 en táctil).
        const lineCount = Math.round((e.tactil ? 7 : 10) + (dn - 1) * (8 / 9));
        const lineas = [];
        for (let i = 0; i < lineCount; i++) {
            lineas.push({ phase: i * 0.7, amp: 0.04 + (i % 3) * 0.015, freq: 1.2 + (i % 4) * 0.4 });
        }
        return {
            w: e.w, h: e.h, rgb: rgbDeBase(e.c1),
            alpha: e.alfa,
            // OJO: su velocidad por defecto es 4, no 5.
            speed: (p.speed != null ? p.speed : 4) * 0.06,
            step: e.tactil ? 16 : 12,       // muestreo en x (px)
            lineas: lineas,
        };
    },

    redimensionar(s, w, h) {
        s.w = w;
        s.h = h;
    },

    dibujar(s, ctx, t) {
        const rgb = s.rgb, W = s.w, H = s.h;
        const time = t * 0.001;
        ctx.lineWidth = 1;
        ctx.strokeStyle = `rgba(${rgb.r},${rgb.g},${rgb.b},${s.alpha})`;

        const gap = H / (s.lineas.length + 1);
        for (let i = 0; i < s.lineas.length; i++) {
            const l = s.lineas[i];
            const baseY = gap * (i + 1);
            ctx.beginPath();
            for (let x = 0; x <= W; x += s.step) {
                const nx = x / W;
                const y = baseY
                    + Math.sin(nx * Math.PI * 2 * l.freq + time * s.speed + l.phase) * (l.amp * H)
                    + Math.sin(nx * Math.PI * 2 * l.freq * 2.3 + time * s.speed * 0.7 + l.phase * 1.6) * (l.amp * H * 0.4);
                if (x === 0) ctx.moveTo(0, y);
                else ctx.lineTo(x, y);
            }
            ctx.stroke();
        }
    },
};
